/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { get, map, noop } from 'lodash';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import FormSelect from 'components/forms/form-select';
import Card from 'components/card';
import FormToggle from 'components/forms/form-toggle';
import { getCurrentUsername } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const EditDetails = ({ onChange = noop, connection, weblinkGroups, defaultValues, ...props }) => {
    if (!connection) {
        return null;
    }

    const [values, setValues] = useState(defaultValues || {});

    const handleOnChange = (e) => {
        let a = {
            ...values,
        };
        a[e.target.name] = e.target.value;
        setValues(a);
        onChange({ ...a });
    };

    return (
        <React.Fragment>
            <Card.Section>
                <Stack space="large">
                    <Box>
                        <FormLabel>Name:</FormLabel>
                        <FormTextInput name='name' value={get(values, 'name')} onChange={handleOnChange} />
                    </Box>
                    <Box>
                        <FormLabel>Weblink Group Number:</FormLabel>
                        <FormSelect
                            onChange={handleOnChange}
                            name='group_code'
                            value={get(values, 'group_code')}
                        >
                            <option value='' />
                            {map(weblinkGroups, ({ name }) => (
                                (props.username.toUpperCase() == "GIF3122") ?
                                <option value={name} key={name}>
                                    {`${name}`}
                                </option>
                                :
                                (name != '24') ? (
									<option value={name} key={name}>
										{`${name}`} 
									</option>) : (
									''
								) 
                            ))}
                        </FormSelect>
                    </Box>
                </Stack>
            </Card.Section>
            <Card.Section>
                <Box display='flex' alignItems='center' justifyContent='spaceBetween'>
                    <FormLabel>Enabled:</FormLabel>
                    <FormToggle
                        name='enabled'
                        checked={get(values, 'enabled')}
                        onChange={(checked) => {
                            let a = {
                                ...values,
                            };
                            a['enabled'] = checked;
                            setValues(a);
                            onChange({ ...a });
                        }}
                    />
                </Box>
            </Card.Section>
        </React.Fragment>
    );
};

export default connect((state) => ({
    username: getCurrentUsername(state),
}), {})(EditDetails);
